const INFO = {
	main: {
		title: "Joseph Dinsmoor",
		name: "Joseph Dinsmoor.",
		email: "jdinsmoor@dinsmoor.pw",
		resume: "../resume.pdf",
		logo: "../logo.jpg",
	},

	socials: {
		twitter: "https://twitter.com/joedinsmoor",
		github: "https://github.com/joedinsmoor",
		linkedin: "https://linkedin.com/in/joseph-dinsmoor",
		instagram: "https://instagram.com/joedinsmoor",
		resume: "../resume.pdf"
	},

	homepage: {
		title: "Software Developer specializing in Python and C++",
		description:
			"I am a software developer with expertise in Python, C++, and most other Object Oriented Languages. I have experience in building scalable, secure and reliable web applications using various frameworks and technologies. I enjoy solving complex problems and learning new skills. I am passionate about creating high-quality code that follows best practices and industry standards. I am always looking for new challenges and opportunities to grow as a developer.",
	},

	about: {
		title: "I'm Joseph Dinsmoor. I am a Software developer specializing in Python, C++, and most other object oriented languges.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. In my spare time, I play guitar in a Deathcore band called Ill Doctrine. I also build tube guitar amplifiers for guitar players across the east coast.",
	},

	projects: [
		{
			title: "Swirl Search",
			description:
				"Swirl enterprise search and AI finds and retrieves information from external and internal sources by leveraging traditional search systems. Results are processed with large language models and conversational AI to unlock a wide variety of use cases — from question-answering to insight extraction and workflow automation.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/swirlai/swirl-search",
		},

		{
			title: "KaiOS Scraper",
			description:
				"Custom SQLite Scraper for use with KaiOS SQLite extractions. Used for forensic analysis of burner phones by the Virginia State Police in cyber crime investigations",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/joedinsmoor/KaiOS_Scraper",
		},

		{
			title: "AutoRsync",
			description:
				"A tool for connecting compatible devices to internal Rsync framework for data preservation. I created this tool for backing up all of my household devices to my server and mirror the backups to a cloud storage instance",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/joedinsmoor/autoRsync",
		},

		{
			title: "AutoJLink",
			description:
				"Scripts for automatic memory acquisiton using JLink, primarily used for acquiring firmware binaries of ARM cpus",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/joedinsmoor/autojlink",
		},

		{
			title: "Auto 3D printer path correction",
			description:
				"A program that uses machine vision to compare live images of a 3D printer bed with the associated CAD file",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/cpp/cpp.png",
		},
	],
};

export default INFO;
